import sensitiveView from './sensitiveView';
// 葡萄牙-巴西
import { setLang } from './all';

const KEY = 'pu';

const obj = setLang(KEY);

export default {
  sensitiveView: sensitiveView.ptBr,
  ...obj
};
